import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Overview-index-1992f2b7a0b0a3635-1'),
    routerUrl: '/Overview',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Overview')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Overview-index-1992f2b7a0b0a3635-2'),
        routerUrl: '/OverviewForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./OverviewForm')),
      },
      //$MORE$
    ],
  },
];
